import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import TileCard from './util/TileCard.vue';
import { useReportingMonthStoreHistory } from "@/stores/reportingHistory"
import { onMounted } from 'vue';
import { formatLocaleDateWithTime, formatTRUELocaleDateWithTime } from "@/common/date"


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyHistory',
  props: {
  userId: { Type: {} as string, default: "" as string },
  year: { Type: {} as number },
  month: { Type: {} as number },
},
  setup(__props) {

const historyStore = useReportingMonthStoreHistory();

const props = __props;

onMounted(async () => {
  await historyStore.loadHistory(props.year, props.month + 1, props.userId);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TileCard, {
    id: "monthly-history",
    loaded: _unref(historyStore).getAllLoaded
  }, {
    body: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "title-2" }, "Monthly record history", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historyStore).getAll, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.actionDate,
          class: "pes"
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(formatTRUELocaleDateWithTime)(new Date(item.actionDate))), 1),
          _createElementVNode("span", null, _toDisplayString(item.record), 1),
          (item.comment)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, ": " + _toDisplayString(item.comment), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["loaded"]))
}
}

})